<template>
  <!-- 4G智能拐杖列表 -->
  <div class="buttonlist">
    <div class="buttonlist-m">
      <el-form :inline="true" :model="formInline" class="demo-form-inline toolbar" style="padding-bottom: 0px"
        @submit.native.prevent>
        <el-form-item label="设备编号">
          <el-input v-model.trim="formInline.inputdeviceno" placeholder="请输入设备编号" clearable
            @keyup.enter.native.prevent="onSubmit"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" plain @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>

      <div v-loading="loading" element-loading-text="拼命加载中......">
        <el-table :data="list" style="width: 100%" :row-style="tableRowStyle" :header-cell-style="tableHeaderColor">
          <el-table-column label="设备编号" align="center" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span>{{ scope.row.deviceNo }}</span>
            </template>
          </el-table-column>
          <el-table-column label="设备名称" align="center" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span>{{ scope.row.deviceName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="设备描述" align="center" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span>{{ scope.row.remark }}</span>
            </template>
          </el-table-column>
          <el-table-column label="设备位置" min-width="120" align="center" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span>{{ scope.row.location }}</span>
            </template>
          </el-table-column>
          <el-table-column label="老人姓名" align="center" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span style="color:orange" v-if="scope.row.oldmanName == null && scope.row.location == null">暂未绑定</span>
              <span style="color:red"    v-else-if="!scope.row.oldmanName">无</span>
              <span v-else>{{ scope.row.oldmanName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="在线状态" align="center">
            <template slot-scope="scope">
              <span style="color:green" v-if="scope.row.online == 1">在线</span>
              <span style="color:red"   v-else-if="scope.row.online == 0">离线</span>
              <span v-else>未知</span>
            </template>
          </el-table-column>
          <el-table-column label="电量" align="center" width="80">
            <template slot-scope="scope">
              <span v-if="caneDataMap[scope.row.deviceNo]">
                {{ caneDataMap[scope.row.deviceNo].batteryLevel }}%
              </span>
              <span v-else style="color:#ccc">—</span>
            </template>
          </el-table-column>
          <el-table-column label="信号" align="center" width="80">
            <template slot-scope="scope">
              <span v-if="caneDataMap[scope.row.deviceNo]">
                {{ caneDataMap[scope.row.deviceNo].signalStrength }}
              </span>
              <span v-else style="color:#ccc">—</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="420" align="center">
            <template slot-scope="scope">
              <el-button type="info"    size="mini" plain @click="showLogList(scope.row)">日志</el-button>
              <el-button type="success" size="mini" plain @click="showMap(scope.row)">定位</el-button>
              <el-button type="primary" size="mini" plain @click="handleEdit(scope.row)">编辑</el-button>
              <el-button type="danger"  size="mini" plain @click="handleDelete(scope.row)">删除</el-button>
              <el-button type="warning" size="mini" plain @click="showCommands(scope.row)">指令</el-button>
              <el-button type="success" size="mini" plain @click="handDetail(scope.row)">数据</el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          layout="total, prev, pager, next"
          :total="totalDataNumber"
          :page-size="pageSize"
          align="center"
          class="fenye">
        </el-pagination>
      </div>

      <!-- 设备日志 -->
      <el-dialog title="设备日志" width="70%" style="margin-top:-80px"
        :visible.sync="logListVisible" :close-on-click-modal="false">
        <device-log-table :deviceNo="currDeviceNo"></device-log-table>
        <div slot="footer" class="dialog-footer" align="center">
          <el-button @click="logListVisible = false">关 闭</el-button>
        </div>
      </el-dialog>

      <!-- 位置地图 -->
      <el-dialog class="el-dialog-map" width="70%" title="位置信息" style="margin-top:-80px"
        :visible.sync="mapDialogVisible" :close-on-click-modal="false">
        <device-location-page :deviceId="currDeviceId" :deviceNo="currDeviceNo"></device-location-page>
        <div slot="footer" class="dialog-footer" align="center">
          <el-button type="primary" @click="mapDialogVisible = false">确定</el-button>
        </div>
      </el-dialog>

      <!-- 编辑 -->
      <el-dialog title="修改设备信息" :visible.sync="dialogFormEdit" :close-on-click-modal="false"
        :close-on-press-escape="false" class="dangerbuttonedit">
        <el-form ref="formedit" :model="formedit" :rules="rules">
          <el-form-item label="设备编号" :label-width="formLabelWidth" prop="editdate">
            <el-input disabled v-model.trim="formedit.editdate" placeholder="设备编号"></el-input>
          </el-form-item>
          <el-form-item label="设备名称" :label-width="formLabelWidth" prop="editname">
            <el-input v-model.trim="formedit.editname" placeholder="请输入设备名称"></el-input>
          </el-form-item>
          <el-form-item label="设备描述" :label-width="formLabelWidth" prop="editsec">
            <el-input v-model.trim="formedit.editsec" type="textarea" :rows="3" placeholder="请输入设备描述"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer" align="center">
          <el-button @click="dialogFormEdit = false">取 消</el-button>
          <el-button type="primary" @click="submitFormEdit('formedit')" :loading="editLoading">确 定</el-button>
        </div>
      </el-dialog>

      <!-- 指令下发 -->
      <el-dialog title="设备指令下发" :visible.sync="cmdDialogVisible" :close-on-click-modal="false"
        class="cmdDialog" width="380px">
        <div class="cmd-panel">
          <div class="cmd-device-no">设备：{{ currDeviceNo }}</div>

          <el-button type="primary" size="small" plain style="width:100%;margin-bottom:10px"
            :loading="cmdLoading.findDevice" @click="sendCmd('findDevice')">
            查找设备（响铃/震动）
          </el-button>

          <el-button type="warning" size="small" plain style="width:100%;margin-bottom:10px"
            :loading="cmdLoading.manualLoc" @click="sendCmd('manualLoc')">
            手动触发定位
          </el-button>

          <el-button type="danger" size="small" plain style="width:100%;margin-bottom:10px"
            :loading="cmdLoading.reboot" @click="sendCmd('reboot')">
            重启设备
          </el-button>

          <el-divider>SOS 紧急号码</el-divider>
          <el-input v-model.trim="sosPhone" placeholder="请输入11位手机号" maxlength="11" style="margin-bottom:10px">
            <el-button slot="append" :loading="cmdLoading.sosPhone" @click="sendCmd('sosPhone')">下 发</el-button>
          </el-input>

          <el-divider>上传间隔（秒）</el-divider>
          <el-input-number v-model="uploadInterval" :min="10" :max="3600" style="width:100%;margin-bottom:10px">
          </el-input-number>
          <el-button type="success" size="small" plain style="width:100%"
            :loading="cmdLoading.uploadInterval" @click="sendCmd('uploadInterval')">
            设置上传间隔
          </el-button>
        </div>
        <div slot="footer" class="dialog-footer" align="center">
          <el-button @click="cmdDialogVisible = false">关 闭</el-button>
        </div>
      </el-dialog>

    </div>
  </div>
</template>

<script>
import bus from "@/vuex/eventBus";
import deviceLogTable from "@/components/DeviceLogTable";
import deviceLocationPage from "@/components/DeviceLocationPage";

export default {
  components: { deviceLogTable, deviceLocationPage },
  data() {
    return {
      currentPage: 1,
      pageNum: 1,
      pageSize: 10,
      totalDataNumber: 0,
      loading: false,
      editLoading: false,
      list: [],
      caneDataMap: {},  // deviceNo → cane data (battery / signal)

      logListVisible: false,
      mapDialogVisible: false,
      dialogFormEdit: false,
      cmdDialogVisible: false,

      currDeviceNo: "",
      currDeviceId: "",

      formInline: { inputdeviceno: "" },
      formLabelWidth: "120px",
      formedit: { editdate: "", editname: "", editsec: "" },
      rules: {
        editdate: [{ required: true, message: "不能为空", trigger: "blur" }],
        editname: [{ min: 1, max: 30, message: "长度在1到30个字符" }],
        editsec:  [{ min: 1, max: 100, message: "长度在1到100个字符" }],
      },

      // 指令
      sosPhone: "",
      uploadInterval: 60,
      cmdLoading: {
        findDevice: false,
        manualLoc: false,
        reboot: false,
        sosPhone: false,
        uploadInterval: false,
      },
    };
  },
  methods: {
    tableRowStyle({ rowIndex }) {
      return rowIndex % 2 === 0 ? "background-color:#ffffff" : "background-color:#e4f5f8";
    },
    tableHeaderColor({ rowIndex }) {
      if (rowIndex === 0)
        return "color:#2d2d2d;font-weight:600;text-align:center;font-size:16px;background-color:#d4f5fa;";
    },

    onSubmit() {
      this.pageNum = 1;
      this.getTableData();
    },

    showLogList(row) {
      this.currDeviceNo = row.deviceNo;
      this.logListVisible = true;
    },
    showMap(row) {
      this.currDeviceNo = row.deviceNo;
      this.currDeviceId = row.id;
      this.mapDialogVisible = true;
    },
    handDetail(row) {
      bus.$emit("homePage", {
        type: "jump",
        path: "/caneDetail",
        title: "拐杖详情",
        params: { deviceNo: row.deviceNo, deviceId: row.id },
      });
    },

    handleEdit(row) {
      this.dialogFormEdit = true;
      this.formedit = Object.assign({}, row);
      this.$set(this.formedit, "editdate", row.deviceNo);
      this.$set(this.formedit, "editname", row.deviceName);
      this.$set(this.formedit, "editsec",  row.remark);
    },
    submitFormEdit(refName) {
      this.$refs[refName].validate((valid) => {
        if (!valid) return;
        this.editLoading = true;
        this.$postJson("dmc/commonDevice/edit", {
          id: this.formedit.id,
          deviceNo: this.formedit.editdate,
          deviceName: this.formedit.editname,
          remark: this.formedit.editsec,
        }).then((res) => {
          this.editLoading = false;
          this.dialogFormEdit = false;
          this.$message({ type: res.code == 200 ? "success" : "error", message: res.message });
          if (res.code == 200) this.getTableData();
        });
      });
    },

    handleDelete(row) {
      if (row.bindType != null) {
        this.$message({ type: "error", message: "该设备已绑定，请先解绑后再删除！" });
        return;
      }
      this.$confirm("此操作将永久删除该设备，是否继续？", "提示", {
        confirmButtonText: "确定", cancelButtonText: "取消", type: "warning", center: true,
      }).then(() => {
        this.$postJson("dmc/commonDevice/deleteById/" + row.id).then((res) => {
          this.$message({ type: res.code == 200 ? "success" : "error", message: res.message });
          if (res.code == 200) this.getTableData();
        });
      });
    },

    showCommands(row) {
      this.currDeviceNo = row.deviceNo;
      this.sosPhone = "";
      this.uploadInterval = 60;
      this.cmdDialogVisible = true;
    },

    sendCmd(type) {
      const imei = this.currDeviceNo;
      if (!imei) return;
      this.cmdLoading[type] = true;

      let url = "";
      let params = {};

      if (type === "findDevice") {
        url = `dmc/cane/command/findDevice/${imei}`;
      } else if (type === "manualLoc") {
        url = `dmc/cane/command/manualLoc/${imei}`;
      } else if (type === "reboot") {
        url = `dmc/cane/command/reboot/${imei}`;
      } else if (type === "sosPhone") {
        if (!this.sosPhone || this.sosPhone.length !== 11) {
          this.$message({ type: "error", message: "请输入正确的11位手机号" });
          this.cmdLoading[type] = false;
          return;
        }
        url = `dmc/cane/command/sosPhone/${imei}`;
        params = { phone: this.sosPhone };
      } else if (type === "uploadInterval") {
        url = `dmc/cane/command/uploadInterval/${imei}`;
        params = { seconds: this.uploadInterval };
      }

      this.$postJson(url, params).then((res) => {
        this.cmdLoading[type] = false;
        this.$message({ type: res.code == 200 ? "success" : "error", message: res.message });
      }).catch(() => {
        this.cmdLoading[type] = false;
      });
    },

    getTableData() {
      this.loading = true;
      this.$postJson("dmc/commonDevice/queryDeviceStatusWithPage", {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        deviceNo: this.formInline.inputdeviceno,
        deviceType: 64,
      }).then((res) => {
        this.loading = false;
        const result = res.result;
        if (result && result.list && result.list.length > 0) {
          this.list = result.list;
          this.totalDataNumber = result.total * 1;
          this.currentPage = result.pageNum;
          this.pageSize = result.pageSize;
          // 批量查询拐杖实时状态（电量/信号）
          this.list.forEach((item) => {
            this.$postForm(`dmc/cane/data/${item.deviceNo}`).then((r) => {
              if (r.code == 200 && r.result) {
                this.$set(this.caneDataMap, item.deviceNo, r.result);
              }
            }).catch(() => {});
          });
        } else {
          this.list = [];
          this.totalDataNumber = 0;
        }
      }).catch(() => { this.loading = false; });
    },

    handleSizeChange(val) { this.pageSize = val; this.getTableData(); },
    handleCurrentChange(val) { this.pageNum = val; this.getTableData(); },
  },
  created() {
    this.getTableData();
  },
};
</script>

<style lang="scss" scoped>
.buttonlist {
  .buttonlist-m { padding: 10px 0 0 5px; }
}
.fenye { margin: 0; padding: 30px 0; background: #fff; }
.dialog-footer { margin-top: -15px; }

.cmd-panel {
  padding: 0 10px;
  .cmd-device-no {
    font-size: 13px;
    color: #666;
    margin-bottom: 16px;
    padding: 6px 10px;
    background: #f5f7fa;
    border-radius: 4px;
  }
}

::v-deep .el-dialog__header {
  text-align: left;
  background: rgb(238, 231, 231);
  border-bottom: 2px solid rgb(211, 207, 207);
}
@media screen and (min-width: 1200px) {
  ::v-deep .dangerbuttonedit .el-dialog { width: 30% !important; }
  ::v-deep .cmdDialog .el-dialog { width: 380px !important; }
}
</style>
